export default {
  FastCheckout: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "fast-checkout"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/FastCheckout.js
// module id = kfBp
// module chunks = 13